import { useMutation } from 'react-query'

import {
  navatticService,
  type NavatticServiceError,
} from '@webapp/core/services/Navattic'

interface TakeProductTourParams {
  url: string
  title?: string
}

export const useMutateTakeProductTour = () => {
  const mutation = useMutation<
    void,
    NavatticServiceError,
    TakeProductTourParams
  >({
    mutationFn: ({ url, title }) => navatticService.openTour(url, { title }),
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
